(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["logo-mockup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initMockup = (root) => {
      if (root.dataset.lvInit) return;
      root.dataset.lvInit = '1';

      const input = root.querySelector('.lv-mockup__input');
      const drop = root.querySelector('.lv-mockup__drop');
      const fileLabel = root.querySelector('.lv-mockup__drop-file');
      const stage = root.querySelector('.lv-mockup__stage');
      const canvasEl = root.querySelector('.lv-mockup__canvas');
      const base = root.querySelector('.lv-mockup__base');
      const area = root.querySelector('.lv-mockup__area');
      const guideV = root.querySelector('.lv-mockup__guide--v');
      const guideH = root.querySelector('.lv-mockup__guide--h');
      const contorno = root.querySelector('[data-lv-contorno]');
      const zonaNota = root.querySelector('[data-lv-zona]');
      const previa = root.querySelector('[data-lv-previa]');
      const sizeSlider = root.querySelector('[data-lv-size]');
      const sizeLabel = root.querySelector('[data-lv-size-label]');
      const dlBtn = root.querySelector('[data-lv-download]');
      const resetBtn = root.querySelector('[data-lv-reset]');
      const priceEl = root.querySelector('[data-lv-price]');
      const specEl = root.querySelector('[data-lv-spec]');
      const hintEl = root.querySelector('[data-lv-hint]');
      const rasterEl = root.querySelector('[data-lv-raster]');
      const envolveEl = root.querySelector('[data-lv-envolve]');
      const envolveTxt = root.querySelector('[data-lv-envolve-texto]');
      const viewBtns = root.querySelectorAll('[data-lv-view]');
      if (!input || !base || !area) return;

      const EXTRA_PRICE_RAW = (root.dataset.extraPrice || 'X').trim();
      const EXTRA_PRICE_NUM = parseFloat(EXTRA_PRICE_RAW.replace(',', '.'));
      const FEE_VARIANT = (root.dataset.feeVariant || '').trim();

      // Textos traduzidos, injetados pelo Liquid via JSON — este bloco de
      // javascript do tema não é processado pelo Liquid. Se o JSON faltar, o
      // bloco continua a funcionar; fica apenas sem os avisos escritos.
      const T = (() => {
        const el = root.querySelector('[data-lv-i18n]');
        try { return JSON.parse(el.textContent); } catch (e) { return {}; }
      })();
      // substitui os marcadores de interpolação das strings de locale
      const fmt = (chave, vars) =>
        (T[chave] || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) =>
          vars && k in vars ? vars[k] : ''
        );

      // A pré-visualização é indicativa — centrada na área de impressão. O que
      // vai para o fornecedor é a arte tal como o cliente a carregou, mais a
      // zona e o tamanho; ele enquadra do lado dele.
      const HINT = T.hint || '';

      // ── estado por lado (frente / costas) ────────────────────────
      const parseArea = (metaStr, fallback) => {
        const a = { ...fallback };
        if (metaStr) {
          const parts = metaStr.split(',').map((s) => s.trim());
          if (parts.length >= 5) {
            a.x = parseFloat(parts[0]);
            a.y = parseFloat(parts[1]);
            a.w = parseFloat(parts[2]);
            a.h = parseFloat(parts[3]);
            a.cm = parseFloat(parts[4]);
            if (parts[5] === 'screen' || parts[5] === 'multiply' || parts[5] === 'normal') a.blend = parts[5];
          }
        }
        return a;
      };

      const settingsArea = {
        x: parseFloat(root.dataset.areaX) || 30,
        y: parseFloat(root.dataset.areaY) || 22,
        w: parseFloat(root.dataset.areaW) || 40,
        h: parseFloat(root.dataset.areaH) || 48,
        cm: parseFloat(root.dataset.areaCm) || 30,
        blend: 'multiply',
      };
      const frontArea = parseArea(root.dataset.areaMeta, settingsArea);
      const backArea = parseArea(root.dataset.areaMetaBack, frontArea);

      // x/y fixos no centro da zona e rot sempre 0: a Makito não recebe
      // posição nem ângulo, portanto não se deixa o cliente mexer neles.
      const STAMP_DEFAULTS = { x: 50, y: 50, w: 55, rot: 0 };
      const makeView = (label, A, baseSrc, metafield, startStamps) => ({
        label,
        A: { ...A },
        cmPerW: A.w > 0 ? A.cm / A.w : 1, // escala física: redimensionar a área ajusta os cm
        baseSrc,
        metafield,
        stamps: startStamps.map((s) => ({ ...s })),
        active: 0,
      });

      // ── zonas reais da Makito, quando o produto as tem ───────────
      // Sem o metafield (produtos que não vêm da Makito) mantém-se o par
      // frente/costas de sempre, para o bloco nunca ficar sem vistas.
      let makito = null;
      const areasTag = root.querySelector('[data-lv-areas]');
      if (areasTag) {
        try {
          const parsed = JSON.parse(areasTag.textContent || '{}');
          if (parsed && Array.isArray(parsed.areas) && parsed.areas.length) makito = parsed;
        } catch (e) {
          /* metafield estragado: cai no par frente/costas */
        }
      }

      const views = {};
      if (makito) {
        makito.areas.forEach((a) => {
          // sem caixa calibrada a zona continua a existir (e a ir na encomenda),
          // só não tem pré-visualização fiel — herda a área da primeira
          const box = a.caixa
            ? { x: a.caixa.x, y: a.caixa.y, w: a.caixa.w, h: a.caixa.h,
                cm: (a.mm && a.mm[0] ? a.mm[0] / 10 : settingsArea.cm), blend: 'multiply' }
            : { ...settingsArea };
          // Nos têxteis a foto da loja é de estúdio, com modelo: a área não se
          // consegue lá situar. Para esses, a.imagem traz a peça plana do
          // fornecedor já limpa da marcação, e a caixa é medida nessa mesma
          // imagem — sem mapeamento entre fotos, portanto exacta.
          const baseZona = a.imagem || base.dataset.srcFront || base.src;
          const v = makeView(a.nome || a.id, box, baseZona, 'custom.areas_makito', []);
          v.makito = {
            ref: makito.ref, area: a.id, posicao: a.posicao, face: a.face,
            mm: a.mm, tecnicas: a.tecnicas || [], calibrada: !!a.caixa,
            poligono: a.poligono || null, envolve: !!a.envolve,
            // 27 zonas não têm imagem publicada pelo fornecedor. São zonas
            // válidas e vão na encomenda, mas não há onde mostrar o logo —
            // mais vale dizê-lo do que desenhar uma caixa inventada.
            semPreview: !a.imagem,
          };
          views[a.id] = v;
        });
      } else {
        views.front = makeView('Frente', frontArea, base.dataset.srcFront || base.src,
                               'custom.area_estampagem', []);
        views.back = makeView('Costas', backArea, base.dataset.srcBack || base.src,
                              'custom.area_estampagem_verso', []);
      }
      const VIEW_KEYS = Object.keys(views);
      let curView = VIEW_KEYS[0];
      const cur = () => views[curView];

      // Zona que contorna a peça (metafield `envolve`). Nestas não se desenha
      // o logo em lado nenhum — nem no ecrã, nem no mockup que segue no
      // carrinho — porque uma foto plana não consegue mostrar o que dá a volta.
      const envolve = (v) => !!(v && v.makito && v.makito.envolve);

      let logoNatural = { w: 1, h: 1 };
      const logoBitmap = new Image();
      let logoURL = null;
      let currentFile = null;
      let mockupTimer = null;
      const stampEls = [];

      // inputs escondidos dentro do form de compra (line item properties)
      const form = document.getElementById(root.dataset.formId);
      const carriers = {};
      // Os nomes das propriedades ficam SEMPRE em português, em qualquer idioma:
      // são a chave que identifica a linha na encomenda e no encomendar_makito.py.
      // Traduzi-los partiria encomendas feitas noutro idioma. Só os valores são
      // traduzidos.
      const carrier = (name, type) => {
        if (!form) return null;
        if (!carriers[name]) {
          const el = document.createElement('input');
          el.type = type;
          el.name = 'properties[' + name + ']';
          el.hidden = true;
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
          form.appendChild(el);
          carriers[name] = el;
        }
        return carriers[name];
      };

      // ── geometria / bloqueio à área ───────────────────────────────
      const areaRatio = () => {
        const r = area.getBoundingClientRect();
        return r.height > 0 ? r.width / r.height : 1;
      };
      const logoRatio = () => logoNatural.h / logoNatural.w;

      const rotatedBox = (w, rotDeg) => {
        const rad = (Math.abs(rotDeg) * Math.PI) / 180;
        const h = w * logoRatio();
        const bw = w * Math.cos(rad) + h * Math.sin(rad);
        const bh = (w * Math.sin(rad) + h * Math.cos(rad)) * areaRatio();
        return { bw, bh };
      };

      const maxWidthFor = (rotDeg) => {
        const rad = (Math.abs(rotDeg) * Math.PI) / 180;
        const lr = logoRatio();
        const limW = 100 / (Math.cos(rad) + lr * Math.sin(rad));
        const limH = 100 / ((Math.sin(rad) + lr * Math.cos(rad)) * areaRatio());
        return Math.max(8, Math.min(limW, limH));
      };

      // A estampa vive sempre centrada e sem rotação: só há que travar a
      // largura no máximo que a zona aceita, para nada transbordar.
      const clampStamp = (s) => {
        s.rot = 0;
        s.x = 50;
        s.y = 50;
        s.w = Math.min(s.w, maxWidthFor(0));
      };

      // ── área: contorno real + posicionamento ──────────────────────
      const fmt1 = (n) => Math.round(n * 10) / 10;

      // Contorno real da zona: o polígono vem em % da IMAGEM e a área está
      // posicionada nessa mesma imagem, por isso converte-se para % da caixa
      // da área — é assim que o clip-path recorta o logo pela forma verdadeira,
      // e não por um rectângulo.
      const pontosDaCaixa = (v) => {
        const pol = v.makito && v.makito.poligono;
        if (!pol || pol.length < 3) return null;
        const A = v.A;
        if (!(A.w > 0 && A.h > 0)) return null;
        return pol.map(([px, py]) => [
          ((px - A.x) / A.w) * 100,
          ((py - A.y) / A.h) * 100,
        ]);
      };

      const desenhaContorno = () => {
        const v = cur();
        const pol = v.makito && v.makito.poligono;
        if (!contorno) return;
        if (!pol || pol.length < 3) {
          contorno.hidden = true;
          area.style.clipPath = '';
          return;
        }
        contorno.hidden = false;
        contorno.querySelector('polygon').setAttribute(
          'points', pol.map(([x, y]) => x + ',' + y).join(' '));
        const rel = pontosDaCaixa(v);
        area.style.clipPath = rel
          ? 'polygon(' + rel.map(([x, y]) => x + '% ' + y + '%').join(', ') + ')'
          : '';
      };

      const applyArea = () => {
        const A = cur().A;
        if (area) {
          area.style.left = A.x + '%';
          area.style.top = A.y + '%';
          area.style.width = A.w + '%';
          area.style.height = A.h + '%';
        }
        desenhaContorno();
        cur().stamps.forEach(clampStamp);
        paint();
      };

      const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

      // ── especificações + preço ───────────────────────────────────
      const widthCm = (w, v) => ((w / 100) * v.A.cm).toFixed(1);

      // Uma zona, uma estampa: já não há colocações múltiplas nem modo padrão,
      // portanto nunca há extras a cobrar. As funções ficam porque o resto do
      // bloco (preço, carriers) as consulta.
      const placements = () => (cur().stamps.length ? 1 : 0);

      const shownStamps = (v) => v.stamps;

      const extrasCount = () => 0;

      const extraPriceText = (n) => {
        if (!isNaN(EXTRA_PRICE_NUM)) return (n * EXTRA_PRICE_NUM).toFixed(2) + ' €';
        return n + ' × ' + EXTRA_PRICE_RAW + ' €';
      };

      const viewSpec = (v) => {
        const s = v.stamps[0];
        if (!s) return T.sem_estampa || '';
        // quem lê isto no carrinho ou no admin tem de saber que é ao redor
        if (envolve(v)) return T.spec_redor || '';
        return fmt('spec_centrada', { cm: widthCm(s.w, v) });
      };

      // descreve a zona de forma a que quem produz não tenha de adivinhar:
      // nome visível + id Makito + posição do catálogo deles + área útil
      const rotuloZona = (v) => {
        if (!v.makito) return v.label;
        const m = v.makito;
        const mm = m.mm && m.mm[0] ? ' ' + m.mm[0] + '×' + m.mm[1] + 'mm' : '';
        return v.label + ' [' + m.area + (m.posicao ? ' · ' + m.posicao : '') + mm + ']';
      };

      // Uma peça, uma zona: o que vai no carrinho descreve só a zona escolhida.
      const fullSpec = () => {
        const v = cur();
        if (!currentFile || !v.stamps.length) return '';
        return rotuloZona(v) + ' — ' + viewSpec(v);
      };

      // Dimensões da estampagem em mm — o que o PrintingJobDTO da Makito aceita
      // em `width`/`height`. A largura sai da percentagem da zona que o cliente
      // escolheu no slider; a altura acompanha o rácio do logo, travada pela
      // altura da zona.
      const medidaMm = (v) => {
        // Ao redor não se manda medida: o cliente não escolheu nenhuma (não há
        // slider) e inventar um número seria pior do que deixar o fornecedor
        // ajustar à faixa, que é o que ele faz de qualquer maneira.
        if (envolve(v)) return null;
        const mm = (v.makito && v.makito.mm) || [];
        const zw = parseFloat(mm[0]);
        const zh = parseFloat(mm[1]);
        if (!(zw > 0 && zh > 0)) return null;
        const s = v.stamps[v.active];
        if (!s) return null;
        const largura = (s.w / 100) * zw;
        const altura = Math.min(largura * logoRatio(), zh);
        return { largura_mm: Math.round(largura), altura_mm: Math.round(altura) };
      };

      // O que a encomenda para a Makito precisa, em JSON e não em prosa: ref,
      // área (A1/A2…), técnica e dimensões. Vai escondido no line item para
      // que o envio ao fornecedor não tenha de reinterpretar o texto do spec.
      const specMakito = () => {
        const v = cur();
        if (!makito || !currentFile || !v.stamps.length) return '';
        // Preferir sempre uma técnica full-colour quando o produto tiver uma:
        // imprime a imagem carregada com as cores dela, que é o que o cliente
        // espera, e dispensa perguntar-lhe a cor da tinta. Só quando não
        // existe é que se cai na serigrafia, que usa tintas físicas.
        // O bordado fica de fora: a Makito marca-o como full-colour, mas é
        // linha e não tinta, custa bastante mais que a serigrafia e num têxtil
        // dá um produto diferente do que quem carrega um logótipo espera. Se o
        // bordado fosse elegível ficava com 61 dos 243 produtos, à socapa.
        const tecnicas = v.makito.tecnicas || [];
        const impressao = (x) => x && x.full_color && !/BORDADO/i.test(x.nome || '');
        const t = tecnicas.find(impressao) || tecnicas[0] || {};
        return JSON.stringify({
          ref: makito.ref,
          zona: {
            area: v.makito.area,
            posicao: v.makito.posicao,
            face: v.makito.face,
            mm: v.makito.mm,
            envolve: !!v.makito.envolve,
            tecnica: t.id || null,
            tecnica_nome: t.nome || null,
            // quantas cores a técnica suporta — NÃO é a cor da tinta
            cores: t.cores || null,
            full_color: !!t.full_color,
            colocacoes: placements(),
          },
          // o que segue tal e qual para o PrintingJobDTO
          estampagem: {
            ...(medidaMm(v) || {}),
            centrada: !envolve(v),
            ao_redor: envolve(v),
            // `colors` do PrintingJobDTO. Confirmado em sandbox a 12/08/2026:
            // numa técnica full-colour o campo tem de ir OMITIDO — mandá-lo,
            // mesmo a "000", dá `400 PrintConfig is fullColor, it can't have
            // colors`. Na serigrafia vai "000" (S/C), sem tinta definida.
            cor_tinta: t.full_color ? null : '000',
          },
          arte: { vetor: !!(currentFile && currentFile.type === 'image/svg+xml') },
        });
      };

      const syncCarriers = () => {
        const spec = carrier('Estampagem', 'hidden');
        if (spec) {
          spec.value = fullSpec();
          spec.disabled = !currentFile || !spec.value;
        }
        const extras = extrasCount();
        const extraCarrier = carrier('Estampagens extra', 'hidden');
        if (extraCarrier) {
          extraCarrier.value = fmt('acrescimo', { n: extras, preco: extraPriceText(extras) });
          extraCarrier.disabled = !currentFile || extras === 0;
        }
        // prefixo _ = propriedade oculta ao cliente, visível no admin
        const mk = carrier('_makito', 'hidden');
        if (mk) {
          mk.value = specMakito();
          mk.disabled = !mk.value;
        }
      };

      const paintPrice = () => {
        const extras = extrasCount();
        if (!currentFile || extras === 0) {
          priceEl.hidden = true;
          return;
        }
        const detalhe = VIEW_KEYS
          .map((k) => ({ l: views[k].label, n: placements(views[k]) }))
          .filter((d) => d.n > 0)
          .map((d) => d.l.toLowerCase() + ' ' + d.n)
          .join(' · ');
        priceEl.hidden = false;
        priceEl.textContent = fmt('extras', {
          n: extras, detalhe: detalhe, preco: extraPriceText(extras),
        });
      };

      // ── render das estampas na pré-visualização ──────────────────
      const stampTransform = (v, s) =>
        'translate(-50%, -50%)';

      const renderStamps = () => {
        const v = cur();
        const list = shownStamps(v);
        while (stampEls.length > list.length) stampEls.pop().remove();
        while (stampEls.length < list.length) {
          const img = document.createElement('img');
          img.className = 'lv-mockup__stamp';
          img.alt = T.logo_alt || '';
          img.draggable = false;
          area.appendChild(img);
          stampEls.push(img);
        }
        list.forEach((s, i) => {
          const el = stampEls[i];
          el.dataset.idx = i;
          if (logoURL && el.getAttribute('src') !== logoURL) el.src = logoURL;
          el.style.left = s.x + '%';
          el.style.top = s.y + '%';
          el.style.width = s.w + '%';
          el.style.transform = stampTransform(v, s);
          el.style.mixBlendMode = v.A.blend;
          el.style.display = logoURL && !envolve(v) ? '' : 'none';
        });
      };

      const paint = () => {
        renderStamps();
        specEl.textContent = !currentFile ? '' : rotuloZona(cur()) + ' — ' + viewSpec(cur());
        paintPrice();
        syncCarriers();
        scheduleMockup();
      };

      // ── mockup composto (canvas) → properties ────────────────────
      const composeMockup = (v, done) => {
        if (!currentFile) return;
        const baseImg = new Image();
        baseImg.crossOrigin = 'anonymous';
        baseImg.onload = () => {
          const c = document.createElement('canvas');
          c.width = baseImg.naturalWidth;
          c.height = baseImg.naturalHeight;
          const ctx = c.getContext('2d');
          ctx.drawImage(baseImg, 0, 0);

          const A = v.A;
          const ax = (A.x / 100) * c.width;
          const ay = (A.y / 100) * c.height;
          const aw = (A.w / 100) * c.width;
          const ah = (A.h / 100) * c.height;

          ctx.save();
          ctx.beginPath();
          ctx.rect(ax, ay, aw, ah);
          ctx.clip();
          ctx.globalCompositeOperation = A.blend === 'normal' ? 'source-over' : A.blend;

          // ao redor: o mockup fica só com a foto da zona, tal como o cliente a
          // viu. Desenhar aqui o logo daria ao admin uma imagem que promete um
          // enquadramento que ninguém garantiu.
          if (!envolve(v)) {
            const lr = logoRatio();
            shownStamps(v).forEach((s) => {
              const lw = (s.w / 100) * aw;
              const lh = lw * lr;
              ctx.save();
              ctx.translate(ax + aw / 2, ay + ah / 2); // sempre centrada na zona
              ctx.drawImage(logoBitmap, -lw / 2, -lh / 2, lw, lh);
              ctx.restore();
            });
          }
          ctx.restore();
          done(c);
        };
        baseImg.src = v.baseSrc || base.currentSrc || base.src;
      };

      // Não se gera aqui nenhuma arte de produção: a estampagem parte de vetor
      // e o que segue como `attachment` é o ficheiro original do cliente, tal
      // e qual. O mockup abaixo leva a foto do produto por baixo e serve só
      // para o cliente e para o admin — nunca para estampar.
      const porFicheiro = (carrierEl, canvas, nome) => {
        canvas.toBlob((blob) => {
          if (!blob) return;
          const dt = new DataTransfer();
          dt.items.add(new File([blob], nome, { type: 'image/png' }));
          carrierEl.files = dt.files;
        }, 'image/png');
      };

      const buildMockups = () => {
        // uma zona por linha de carrinho, portanto um mockup só
        VIEW_KEYS.forEach((k) => {
          const v = views[k];
          const mock = carrier('Mockup da estampagem', 'file');
          if (!mock) return;
          const used = k === curView && v.stamps.length > 0;
          mock.disabled = !used;
          if (!used) return;
          composeMockup(v, (c) =>
            porFicheiro(mock, c, 'mockup-' + v.label.toLowerCase() + '.png'));
        });
      };

      const scheduleMockup = () => {
        clearTimeout(mockupTimer);
        mockupTimer = setTimeout(buildMockups, 450);
      };

      // specs atualizadas + taxa de estampagens extra no submit
      if (form && !form.dataset.lvFeeHook) {
        form.dataset.lvFeeHook = '1';
        form.addEventListener(
          'submit',
          () => {
            if (!currentFile) return;
            syncCarriers();
            const extras = extrasCount();
            if (extras > 0 && FEE_VARIANT) {
              const body = {
                items: [{
                  id: parseInt(FEE_VARIANT, 10),
                  quantity: extras,
                  properties: { 'Referente a': 'Estampagens extra — ' + document.title },
                }],
              };
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
              }).catch(() => {});
            }
          },
          true
        );
      }

      // ── carregar ficheiro ────────────────────────────────────────
      const load = (file) => {
        if (!file || !file.type.match(/^image\/(png|jpeg|webp|svg\+xml)$/)) return;
        currentFile = file;
        // A estampagem parte de vetor. O raster passa à mesma — mas ampliar um
        // logo pequeno até ao tamanho da peça perde definição, e mais vale
        // dizê-lo aqui do que o cliente descobrir com a encomenda na mão.
        if (rasterEl) {
          const vetor = file.type === 'image/svg+xml';
          rasterEl.hidden = vetor;
          rasterEl.textContent = vetor ? '' :
            fmt('raster', { formato: (file.type.split('/')[1] || '').toUpperCase() });
        }
        if (logoURL) URL.revokeObjectURL(logoURL);
        logoURL = URL.createObjectURL(file);
        logoBitmap.onload = () => {
          logoNatural = { w: logoBitmap.naturalWidth || 300, h: logoBitmap.naturalHeight || 150 };
          // fica no lado onde o cliente está; trocar de ficheiro preserva a composição
          const hasContent = VIEW_KEYS.some((k) => views[k].stamps.length > 0);
          if (!hasContent) {
            cur().stamps = [{ ...STAMP_DEFAULTS }];
            cur().active = 0;
          }
          stage.hidden = false;
          applyView(curView);
        };
        logoBitmap.src = logoURL;
        fileLabel.textContent = file.name;
        fileLabel.hidden = false;

        const orig = carrier('Logo (ficheiro original)', 'file');
        if (orig) {
          const dt = new DataTransfer();
          dt.items.add(file);
          orig.files = dt.files;
        }
      };

      input.addEventListener('change', () => load(input.files[0]));

      ['dragover', 'dragleave', 'drop'].forEach((evt) =>
        drop.addEventListener(evt, (e) => {
          e.preventDefault();
          drop.classList.toggle('is-dragover', evt === 'dragover');
          if (evt === 'drop' && e.dataTransfer.files[0]) load(e.dataTransfer.files[0]);
        })
      );

      // ── zonas + modos ─────────────────────────────────────────────
      const descreveZona = () => {
        if (!zonaNota) return;
        const m = cur().makito;
        if (!m) { zonaNota.hidden = true; return; }
        const mm = m.mm && m.mm[0] ? m.mm[0] + ' × ' + m.mm[1] + ' mm' : '';
        const tec = (m.tecnicas || [])[0];
        const partes = [mm, tec && tec.nome ? tec.nome.toLowerCase() : ''].filter(Boolean);
        let texto = fmt('area_max', { partes: partes.join(' · ') });
        if (m.semPreview && !m.envolve) texto += T.sem_preview || '';
        zonaNota.textContent = texto;
        zonaNota.hidden = false;
      };

      // O aviso das zonas ao redor é a peça mais importante do ecrã nestes
      // produtos: diz o que vai acontecer e porque é que não há prévia.
      const descreveEnvolve = () => {
        if (!envolveEl) return;
        const v = cur();
        if (!envolve(v)) { envolveEl.hidden = true; return; }
        const m = v.makito;
        const mm = m.mm && m.mm[0] ? m.mm[0] + ' × ' + m.mm[1] + ' mm' : '';
        const outras = VIEW_KEYS.filter((k) => !envolve(views[k]));
        let t = fmt('envolve', {
          medida: mm ? fmt('envolve_medida', { mm: mm }) : '',
        });
        if (outras.length) {
          const zonas = outras
            .map((k) => '“' + views[k].label + '”')
            .join(T.ou || ' ');
          t += fmt(outras.length === 1 ? 'envolve_alt_uma' : 'envolve_alt_varias',
                   { zonas: zonas });
        }
        envolveTxt.textContent = t;
        envolveEl.hidden = false;
      };

      const syncControls = () => {
        const v = cur();
        descreveZona();
        descreveEnvolve();
        // ao redor: fica só a foto do fornecedor, sem caixa da área nem contorno
        root.classList.toggle('lv-mockup--envolve', envolve(v));
        const sem = !!(v.makito && v.makito.semPreview);
        root.classList.toggle('lv-mockup--sem-previa', sem);
        root.querySelectorAll('[data-lv-manual]').forEach((el) => { el.hidden = sem; });
        if (hintEl) hintEl.hidden = sem;
        if (hintEl) hintEl.textContent = HINT;
        sizeLabel.textContent = 'Tamanho';
        sizeSlider.max = 100;
        const s = v.stamps[v.active];
        sizeSlider.value = s ? s.w : STAMP_DEFAULTS.w;
        viewBtns.forEach((b) => b.classList.toggle('is-on', b.dataset.lvView === curView));
      };

      // Uma peça só pode ser estampada numa zona. Ao trocar de zona a
      // composição acompanha e a anterior fica vazia — assim nunca há duas
      // zonas estampadas na mesma linha do carrinho. Quem quiser a mesma peça
      // com estampagem noutra zona adiciona-a ao carrinho outra vez: as
      // propriedades diferem, por isso a Shopify cria uma linha separada.
      function applyView(name) {
        // só se transfere a composição quando a zona muda de facto; o resto
        // corre sempre, porque é aqui que o contorno é desenhado a primeira vez
        if (name !== curView && views[name]) {
          const antes = cur();
          const depois = views[name];
          depois.stamps = antes.stamps.map((s) => ({ ...s }));
          depois.active = antes.active;
          antes.stamps = [];
          antes.active = 0;
          curView = name;
        }
        const v = cur();
        if (v.baseSrc && base.getAttribute('src') !== v.baseSrc) base.src = v.baseSrc;
        syncControls();
        applyArea();
      }

      viewBtns.forEach((b) => b.addEventListener('click', () => applyView(b.dataset.lvView)));

      // imagem trocada (frente/costas) pode ter proporção diferente
      base.addEventListener('load', () => {
        if (!stage.hidden) applyArea();
      });

      // ── controlos ────────────────────────────────────────────────
      // O tamanho é o único ajuste que existe, e é o único que a Makito lê.
      sizeSlider.addEventListener('input', () => {
        const s = cur().stamps[cur().active];
        if (!s) return;
        s.w = parseInt(sizeSlider.value, 10);
        clampStamp(s);
        sizeSlider.value = s.w;
        paint();
      });

      // Pré-visualizar: mostra o mockup final em grande, do tamanho a que o
      // cliente o vai realmente ver, sem os controlos por cima.
      const previaBtn = root.querySelector('[data-lv-preview]');
      const previaImg = root.querySelector('[data-lv-previa-img]');
      const previaTit = root.querySelector('[data-lv-previa-titulo]');
      const previaNota = root.querySelector('[data-lv-previa-nota]');
      const previaFechar = root.querySelector('[data-lv-previa-fechar]');
      let previaURL = null;

      if (previaBtn && previa) {
        previaBtn.addEventListener('click', () => {
          if (!currentFile) return;
          composeMockup(cur(), (c) => {
            c.toBlob((blob) => {
              if (!blob) return;
              if (previaURL) URL.revokeObjectURL(previaURL);
              previaURL = URL.createObjectURL(blob);
              if (previaImg) previaImg.src = previaURL;
              if (previaTit) previaTit.textContent = rotuloZona(cur());
              if (previaNota) previaNota.textContent = viewSpec(cur());
              if (typeof previa.showModal === 'function') previa.showModal();
              else previa.setAttribute('open', '');
            }, 'image/png', 0.92);
          });
        });
      }
      if (previaFechar && previa) {
        previaFechar.addEventListener('click', () => {
          if (typeof previa.close === 'function') previa.close();
          else previa.removeAttribute('open');
        });
      }

      dlBtn.addEventListener('click', () => {
        composeMockup(cur(), (c) => {
          c.toBlob((blob) => {
            if (!blob) return;
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = 'mockup-' + cur().label.toLowerCase() + '.png';
            a.click();
            setTimeout(() => URL.revokeObjectURL(a.href), 5000);
          }, 'image/png', 0.92);
        });
      });

      resetBtn.addEventListener('click', () => {
        VIEW_KEYS.forEach((k) => {
          const v = views[k];
          v.stamps = k === VIEW_KEYS[0] ? [{ ...STAMP_DEFAULTS }] : [];
          v.active = 0;
        });
        applyView(VIEW_KEYS[0]);
      });

      // A estampa não se arrasta nem se roda — fica centrada na zona. As guias
      // de alinhamento deixaram de ter função e mantêm-se escondidas.
      guideV.hidden = true;
      guideH.hidden = true;

      syncControls();
      applyArea();
    };

    const initAll = () => document.querySelectorAll('.lv-mockup').forEach(initMockup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // editor de temas: a secção é re-renderizada a cada alteração de settings
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
